import { render } from "./NewFileModal.vue?vue&type=template&id=6fc0db65&scoped=true"
import script from "./NewFileModal.vue?vue&type=script&lang=js"
export * from "./NewFileModal.vue?vue&type=script&lang=js"

import "./NewFileModal.vue?vue&type=style&index=0&id=6fc0db65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc0db65"]])

export default __exports__